"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppParticipatingActivitesSection = exports.AppParticipatingActivitesSectionDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var utils_1 = require("@shapeable/utils");
var entity_panel_1 = require("../entities/entity-panel");
var event_panel_meta_1 = require("../entities/event-panel-meta");
var team_panel_meta_1 = require("../entities/team-panel-meta");
var program_panel_meta_1 = require("../../config/entities/program-panel-meta");
var utils_2 = require("../../utils");
var use_active_person_1 = require("../../hooks/use-active-person");
var use_entities_1 = require("../../hooks/use-entities");
var cls = (0, utils_1.classNames)('app-participating-activites-section');
exports.AppParticipatingActivitesSectionDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n  "])), theme_1.theme.UNIT(3)),
  desktop: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));\n    grid-template-rows: 1fr;\n    gap: ", ";\n    height: 100%;\n    width: 100%;\n  "], ["\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));\n    grid-template-rows: 1fr;\n    gap: ", ";\n    height: 100%;\n    width: 100%;\n  "])), theme_1.theme.UNIT(3))
});
var EntityPanelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    flex: 1;\n  "], ["\n    flex: 1;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Panels: (0, styled_components_1.default)(entity_panel_1.EntityPanel)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), EntityPanelStyles)
};
var AppParticipatingActivitesSection = function (props) {
  var _a;
  var className = props.className,
    children = props.children,
    entity = props.entity;
  var activePerson = (0, use_active_person_1.useActivePerson)();
  var entities = (0, use_entities_1.useEntities)();
  // const definition = useEntityDefinitionNamed(entityTypeName);
  // const to = definition.toList();
  return react_1.default.createElement(My.Container, {
    className: cls.name(className)
  }, react_1.default.createElement(My.Panels, {
    title: ((_a = entities.Program) === null || _a === void 0 ? void 0 : _a.pluralLabel) || "Programs",
    meta: react_1.default.createElement(program_panel_meta_1.ProgramPanelMeta, {
      items: entity.allPrograms
    })
  }), (0, utils_2.personCanReadHomeSection)(activePerson, 'participating-events') && react_1.default.createElement(My.Panels, {
    title: "Events",
    meta: react_1.default.createElement(event_panel_meta_1.EventPanelMeta, {
      items: entity.allEvents
    })
  }), (0, utils_2.personCanReadHomeSection)(activePerson, 'participating-collaborations') && react_1.default.createElement(My.Panels, {
    title: "Collaborations",
    meta: react_1.default.createElement(team_panel_meta_1.TeamPanelMeta, {
      items: entity.allTeams
    })
  }), children);
};
exports.AppParticipatingActivitesSection = AppParticipatingActivitesSection;
exports.AppParticipatingActivitesSection.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;